import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CardItem = ({ card, hasDetailsLink }) => {
  const status = { GLOSADA: 'Glosa', pendente: 'Pendente', analise: 'Em Análise' }[card.status];
  const color = { Glosa: 'red', Pendente: 'yellow', 'Em Análise': 'blue' }[status];
  const { beneficiary, procedures, gtoId } = card;

  const procedimentos = procedures.length === 1 ? 'procedimento' : 'procedimentos';

  const { nomeBenef } = beneficiary;

  return (
    <li className="card">
      <div>
        <div className={`CardWithLateralLine CardWithLateralLine--${color}`}>
          <div className="col s12">
            <div className="row">
              <div className="col s6 align-left">
                <div className="box-label box-label--top">
                  <span className={`box-label--name ${color}`}>GTO {gtoId}</span>
                  {/*
                    TODO
                    o orcamento também deveria vir pela API
                   */}
                  <span className="box-label--numberCard benefCod">{nomeBenef}</span>
                </div>
                {/* <div className="box-label box-label--bottom">
                  <span>Emissão</span>
                  <span className="box-label--dateStart bottomLeftDescription">{inclusionDateFormated}</span>
                </div> */}
              </div>

              <div className="col s6 align-right">
                <div className="box-label box-label--top">
                  <span className="box-label--consult benefElegivel">{`${procedures.length} ${procedimentos}`}</span>
                </div>

                {hasDetailsLink && (
                  <div className="box-label box-label--bottom">
                    <Link to={{ pathname: '/detalhes-glosa', state: card }}>
                      <span className="box-label--link benefDetails">Ver detalhes</span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

CardItem.defaultProps = {
  hasDetailsLink: true
};

CardItem.propTypes = {
  // card: PropTypes.arrayOf(PropTypes.any).isRequired,
  hasDetailsLink: PropTypes.bool
};

export default CardItem;
